import {resolveBackground} from '#core/utils/color-utils.js';
import {icon} from '#core/utils/style-utils.js';

import {generateSkeletonPart} from '#core/application/modules/tiles/skeleton-part/index.js';

export function eventTipsFactory(PALETTE) {
    const CONTAINER_STYLE = {
        ...resolveBackground(PALETTE.EVENT_TIPS_CONTAINER_BG),
        boxShadow: PALETTE.EVENT_TIPS_CONTAINER_BOX_SHADOW,
    };
    const HEADER_STYLE = {
        ...resolveBackground(PALETTE.EVENT_TIPS_HEADER_CONTAINER_BG),
        minHeight: '40px',
    };
    const EVENT_TIPS_SKELETON_PART = generateSkeletonPart(PALETTE.EVENT_TIPS_SKELETON_PART);

    return {
        EventTips: {
            expandable: {
                container: {
                    style: CONTAINER_STYLE,
                },
                headerContainer: {
                    style: {
                        base: HEADER_STYLE,
                    },
                },
                headerTextContainer: {
                    style: {
                        ...PALETTE.EVENT_TIPS_HEADER_TEXT,
                    },
                },
                rotation: {
                    image: {
                        style: {
                            fill: PALETTE.EVENT_TIPS_HEADER_ROTATION_ICON_COLOR,
                        },
                    },
                },
                leftIcon: icon(PALETTE.EVENT_TIPS_HEADER_TIPS_ICON_COLOR),
            },
        },
        EventTipCard: {
            container: {
                style: {
                    borderStyle: 'solid',
                    borderWidth: '0 1px 0 0',
                    borderColor: PALETTE.EVENT_TIPS_CARD_SEPARATOR_COLOR,
                },
            },
            headerIcon: icon(PALETTE.EVENT_TIPS_CARD_TIP_ICON_COLOR),
            headerText: {
                style: {
                    ...PALETTE.EVENT_TIPS_CARD_TITLE_TEXT,
                },
            },
            cardMarketInfoContainer: {
                style: {
                    justifyContent: 'center',
                },
            },
            selectionText: {
                style: {
                    ...PALETTE.EVENT_TIPS_CARD_SELECTION_NAME_TEXT,
                },
            },
            marketText: {
                style: {
                    ...PALETTE.EVENT_TIPS_CARD_MARKET_NAME_TEXT,
                },
            },
        },
        EventTipsSkeleton: {
            container: {
                style: CONTAINER_STYLE,
            },
            expandableViewHeaderContainer: {
                style: HEADER_STYLE,
            },
            expandableViewHeaderTextSkeleton: generateSkeletonPart(PALETTE.EVENT_TIPS_HEADER_SKELETON_PART),
            cardContainer: {
                style: {
                    borderStyle: 'solid',
                    borderWidth: '0 1px 0 0',
                    borderColor: PALETTE.EVENT_TIPS_CARD_SEPARATOR_COLOR,
                },
            },
            headerIconSkeleon: EVENT_TIPS_SKELETON_PART,
            headerTextSkeleton: EVENT_TIPS_SKELETON_PART,
            marketInfoContainer: {
                style: {
                    justifyContent: 'center',
                },
            },
            marketTextSkeleton: EVENT_TIPS_SKELETON_PART,
            selectionTextSkeleton: EVENT_TIPS_SKELETON_PART,
            selectionButtonSkeleton: EVENT_TIPS_SKELETON_PART,
        },
    };
}
